import {Text} from "@unibuddy/patron";
import {useAnalytics} from "@unibuddy/tracking";
import {intersectionBy} from "lodash";
import {useEffect, useState} from "react";
import useAuth from "ubcommunity-shared/src/Auth/hooks/useAuth";
import {TrackEvents} from "ubcommunity-shared/src/constants";
import {AutocompleteModal} from "ubcommunity-shared/src/General/AutocompleteModal/AutocompleteModal";
import {useAppLocalesQuery, UserLocalePreferenceInput} from "ubcommunity-shared/src/types";

export const EMAIL_TEMPLATES = "email-templates";
export const NOTIFICATIONS = "notifications";

const EditLocalePreference = () => {
    const {authState, loading: authLoading} = useAuth();
    const localePreference = authState?.me?.applicant?.localePreference;
    const {trackEvent} = useAnalytics();
    const {
        data: emailData,
        loading: emailLoading,
        error: emailError,
    } = useAppLocalesQuery({
        variables: {appName: EMAIL_TEMPLATES},
        skip: localePreference,
    });
    const {
        data: notificationData,
        loading: notificationLoading,
        error: notificationError,
    } = useAppLocalesQuery({
        variables: {appName: NOTIFICATIONS},
        skip: localePreference,
    });
    const [appLocales, setAppLocales] = useState<UserLocalePreferenceInput[]>([]);

    useEffect(() => {
        let emailLocales: UserLocalePreferenceInput[] = [];
        let notificationLocales: UserLocalePreferenceInput[] = [];
        if (emailData?.appLocales?.locales && emailData?.appLocales?.locales?.length > 0) {
            emailLocales = emailData.appLocales.locales.map((locale) => ({
                id: locale?.id,
                name: locale?.name,
                locale: locale?.locale,
            }));
        }
        if (
            notificationData?.appLocales?.locales &&
            notificationData?.appLocales?.locales?.length > 0
        ) {
            notificationLocales = notificationData.appLocales.locales.map((locale) => ({
                id: locale?.id,
                name: locale?.name,
                locale: locale?.locale,
            }));
        }
        setAppLocales(intersectionBy(emailLocales, notificationLocales, "locale"));
    }, [emailData?.appLocales, notificationData?.appLocales]);

    const loading = authLoading || emailLoading || notificationLoading;
    const error = emailError || notificationError;
    if (localePreference || loading || error || appLocales.length === 0) {
        return null;
    }

    const handleOnDialogOpened = () => {
        trackEvent(TrackEvents.SELECT_LOCALE_PREFRENCE_OPEN);
    };

    const handleOnDialogDismiss = () => {
        trackEvent(TrackEvents.SELECT_LOCALE_PREFRENCE_DISMISSED);
    };

    return (
        <AutocompleteModal
            name="selectLocalePreference"
            label="Preferred language for notifications?"
            data={appLocales}
            renderItem={(item) => <Text>{item.name}</Text>}
            resultKey="name"
            onDropdownOpened={handleOnDialogOpened}
            onDismiss={handleOnDialogDismiss}
            placeholder="Select language"
        />
    );
};

export default EditLocalePreference;
